import React, { useState, useEffect } from 'react'
// import NumberFormat from 'react-number-format'

import { Buttons } from '../../reusableUI/Buttons'
import { Settings } from '../../../models/settings'
import { NewRule } from './NewRule'
import { Switchs } from '../../reusableUI/Switchs'
import { Tables } from '../../reusableUI/Tables'
import { InputsNumbers } from '../../reusableUI/InputsNumbers'
import { DialogListaValidator } from './DialogListaValidator'

export const AjustesRentabilidad = ({ unitList }) => {

    // const [error, setError] = useState(null)
    const [openNewUser, setOpenNewUser] = useState(false)
    const [rulesList, setRulesList] = useState([])
    const [openValidator, setOpenValidator] = useState(false)
    const [currentIdRule, setCurrentIdRule] = useState(null)

    useEffect(() => {
        getRulesList()
    }, [])

    const getRulesList = async () => {
        setRulesList(await Settings.getAllRules())
    }

    const handleChangeEstado = async ({ target }, id) => {
        const habilitado = target.checked
        const newList = rulesList.map(it => {
            if (parseInt(it.id) === parseInt(id)) {
                return {
                    ...it,
                    habilitado: target.checked
                }
            } else {
                return it
            }

        })

        setRulesList(newList)
        await Settings.updateEstado({ id, habilitado })
    }

    const handleDelete = async (id) => {
        await Settings.deleteRule(id)
        getRulesList()
    }

    const handleEditValidator = async (ruleId) => {
        setCurrentIdRule(ruleId)
        setOpenValidator(true)
    }

    return (

        <div className="p-container-info-personal mt-4">

            {openValidator &&
                <DialogListaValidator
                    ruleId={currentIdRule}
                    open={openValidator}
                    setOpen={setOpenValidator}
                    getRulesList={getRulesList}
                />
            }

            <div className="row p-contet-title-info-personal">
                <div className="col ">
                    <h3 className='text-start p-title-info-personal'>Configuración de reglas de rentabilidad esperada</h3>
                </div>
                <div className="col-12 p-text-info-personal">
                    <h6>Define reglas de rentabilidad esperada de manera general o por unidad de negocio.</h6>
                </div>
            </div>

            <div className='p-container-users'>
                <div>
                    <Buttons
                        label={openNewUser ? ' - Regla' : ' + Añadir regla'}
                        type='button'
                        onClick={() => setOpenNewUser(!openNewUser)}
                    />
                </div>

                {openNewUser &&
                    <NewRule
                        getRulesList={getRulesList}
                        unitList={unitList}
                    />
                }

                {rulesList.length > 0 ?
                    <div className="table-responsive mt-4">
                        <Tables
                            header={['Tipo', 'Unidad de negocio', '% Rentabilidad optima', 'Habilitado', 'Validador(es)', 'Eliminar regla']}
                            rows={rulesList?.map(it => (
                                <tr key={it.id} className='p-tr-body-global'>
                                    <td className='text-start' style={{ textTransform: 'capitalize' }}>{it.nombre_tipo || ''}</td>
                                    <td style={{ textTransform: it.nombre_unidad ? 'capitalize' : '' }}>
                                        {it.nombre_unidad || '( aplica para todos los presupuestos)'}
                                    </td>
                                    <td>
                                        <InputsNumbers
                                            displayType={'text'}
                                            value={parseFloat(it.rentabilidad_esperada) || 0}
                                            type='text'
                                            simbolo='%'
                                        />
                                    </td>
                                    <td className='text-center' style={{ textTransform: 'none' }}>
                                        <Switchs
                                            checked={it.habilitado}
                                            label={it.habilitado ? "Activo" : 'Desactivado'}
                                            onChange={(e, id) => handleChangeEstado(e, it.id)}
                                        />
                                    </td>
                                    <td>

                                        {it?.validators.map(val => (
                                            <span key={val.id} className="p-label-validator">{val.nombre}{" "}{val.apellidos}</span>
                                        ))}

                                        {it?.validators.length === 0 && 'Ninguno'}

                                        <i className="bi bi-pencil p-edit-validator"
                                            title="modificar validadores"
                                            onClick={() => handleEditValidator(it.id)}
                                        ></i>

                                    </td>
                                    <td>
                                        <i
                                            className="bi bi-trash"
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => handleDelete(it.id)}
                                        ></i>
                                    </td>
                                </tr>
                            ))}
                        />
                    </div>
                    :
                    <h3 style={{ fontSize: '14px', margin: '5px' }}>No hay reglas configuradas</h3>
                }


            </div>

        </div>

    )
}